import StatusSlider from './StatusSlider';
import StatusSliderContainer from './StatusSlider.container';

export default StatusSliderContainer(StatusSlider);
